(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal["default"].signature : function (a) {
  return a;
};

import React, { forwardRef } from 'react';
import styled from 'styled-components';
import { HtmlElement } from "../base";
var StyledA = styled(HtmlElement).withConfig({
  displayName: "Anchor__StyledA",
  componentId: "sc-tfvab6-0"
})(["text-decoration:none;color:#0075ff;cursor:pointer;"]); // eslint-disable-next-line react/display-name

var Anchor = forwardRef(function (props, ref) {
  return React.createElement(StyledA, _extends({}, props, {
    ref: ref,
    forwardedAs: "a"
  }));
});
var _default = Anchor;
export default _default;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(StyledA, "StyledA", "/home/vsts/work/1/s/src/components/text/Anchor.js");
  reactHotLoader.register(Anchor, "Anchor", "/home/vsts/work/1/s/src/components/text/Anchor.js");
  reactHotLoader.register(_default, "default", "/home/vsts/work/1/s/src/components/text/Anchor.js");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();